/* ============================================================
   SE MERCI — Variant Image Range
   Filtert die Produktgalerie beim Variantenwechsel nach der
   Featured-Image-Position (wie eine Farb-Varianten-App):
   - Featured Image der Variante = Startindex
   - bis zum nächsten Featured Image (exklusiv) = Endindex
   - letzte Variante = bis zum Listenende
   - nur 1 Variante / keine Featured Images = alle Bilder zeigen
   Steuerung rein über die Upload-Reihenfolge im Shopify Admin.
   ============================================================ */
(function () {
  function init() {
    var dataEl = document.getElementById('VariantImageRange');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.variants || !data.variants.length) return;

    var wrapper = document.querySelector('.m-main-product--wrapper') || document;
    var picker = wrapper.querySelector('variant-picker');
    var idInput =
      (picker && picker.querySelector('[name="id"]')) ||
      wrapper.querySelector('[name="id"]');

    // Variant-ID -> Featured-Index, und Liste der Featured-Grenzen
    var map = {};
    var boundaries = [];
    data.variants.forEach(function (v) {
      map[String(v.id)] = v.featured;
      if (v.featured >= 0 && boundaries.indexOf(v.featured) === -1) {
        boundaries.push(v.featured);
      }
    });
    boundaries.sort(function (a, b) { return a - b; });

    // Regel 4: nur eine (oder keine) Bildgruppe -> nicht filtern, alles zeigen
    if (boundaries.length <= 1) return;

    function rangeFor(featured) {
      if (featured == null || featured < 0) return null; // alle zeigen
      var end = data.totalMedia;
      for (var i = 0; i < boundaries.length; i++) {
        if (boundaries[i] > featured) { end = boundaries[i]; break; }
      }
      return { start: featured, end: end };
    }

    function goToStart() {
      // Nach dem Filtern ist das Featured-Bild das ERSTE sichtbare Slide.
      // Bei loop:false rechnet Swiper die ausgeblendeten Slides raus -> slideTo(0).
      wrapper.querySelectorAll('media-gallery, media-gallery-mobile').forEach(function (g) {
        var sw = g.slider;
        if (!sw || !currentRange) return;
        try {
          if (sw.params && sw.params.loop && typeof sw.slideToLoop === 'function') {
            sw.slideToLoop(0, 0, false);
          } else if (typeof sw.slideTo === 'function') {
            sw.slideTo(0, 0, false);
          }
        } catch (e) {}
      });
    }

    function refreshGalleries() {
      wrapper.querySelectorAll('media-gallery, media-gallery-mobile').forEach(function (g) {
        var sw = g.slider;
        if (sw && typeof sw.update === 'function') {
          try { sw.update(); } catch (e) {}
        }
      });
      window.dispatchEvent(new Event('resize'));
      // erst nach update() auf das erste sichtbare (Featured) Bild springen,
      // und nochmals verzögert, damit der Theme-Scroll nicht "gewinnt".
      goToStart();
      setTimeout(goToStart, 80);
      setTimeout(goToStart, 250);
    }

    // Aktuelle Range merken (für Observer, da Swiper die Bullets neu erzeugt)
    var currentRange = null;

    // Fortschrittslinie: nur die Segmente der aktuellen Variante zeigen.
    // Das i-te Bullet entspricht dem i-ten Bild (data-index i).
    function syncPagination() {
      wrapper.querySelectorAll('.m-main-product--media .swiper-pagination').forEach(function (pg) {
        var bullets = pg.querySelectorAll('.swiper-pagination-bullet, .m-dot');
        if (!bullets.length) return;
        // Wenn Swiper nur die sichtbaren Bullets rendert (loop:false), nichts ausblenden.
        if (bullets.length !== data.totalMedia || !currentRange) {
          bullets.forEach(function (b) { b.style.display = ''; });
          return;
        }
        // Wenn Swiper alle Bullets rendert: die außerhalb der Range ausblenden.
        bullets.forEach(function (b, i) {
          b.style.display = (i >= currentRange.start && i < currentRange.end) ? '' : 'none';
        });
      });
    }

    function apply() {
      var variantId = idInput && idInput.value;
      var featured = variantId != null ? map[String(variantId)] : null;
      currentRange = rangeFor(featured);

      var items = wrapper.querySelectorAll('.m-main-product--media [data-index]');
      items.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-index'), 10);
        if (isNaN(idx)) return;
        var show = !currentRange || (idx >= currentRange.start && idx < currentRange.end);
        el.style.display = show ? '' : 'none';
        el.classList.toggle('sf-media-out-of-range', !show);
      });

      refreshGalleries();
      syncPagination();
    }

    // Bullets werden von Swiper bei Init/Update/Swipe neu erzeugt ->
    // per MutationObserver IMMER wieder auf die aktuelle Range zuschneiden.
    var mediaArea = wrapper.querySelector('.m-main-product--media');
    if (mediaArea && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { syncPagination(); });
      mo.observe(mediaArea, { childList: true, subtree: true });
    }

    // Initial anwenden (+ kurze Nachzieher, falls Swiper später initialisiert)
    apply();
    setTimeout(syncPagination, 150);
    setTimeout(syncPagination, 500);

    // Beim Variantenwechsel (nach dem Theme-Handler) neu filtern
    if (picker) {
      picker.addEventListener('change', function () { setTimeout(apply, 0); });
    }

    // Fallback: Hidden-Input-Wert beobachten (falls 'change' nicht durchschlägt)
    if (idInput) {
      var lastVal = idInput.value;
      setInterval(function () {
        if (idInput.value !== lastVal) {
          lastVal = idInput.value;
          apply();
        }
      }, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
